import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const ExamplesGallery = () => {
  const examples = [
  {
    title: 'E-Commerce Platform',
    description: 'Full-featured online store with product catalog, shopping cart, payment integration, and order management system.',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_12d7de71f-1764676026833.png",
    imageAlt: 'Modern e-commerce website interface showing product grid with shopping cart and checkout features on desktop screen',
    tags: ['React', 'Node.js', 'PostgreSQL', 'Stripe'],
    generationTime: '28s'
  },
  {
    title: 'Project Management Tool',
    description: 'Collaborative workspace with task boards, team management, real-time updates, and progress tracking dashboards.',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c3a7a3bc-1764648271797.png",
    imageAlt: 'Project management dashboard displaying kanban board with task cards, team members, and progress charts on laptop screen',
    tags: ['React', 'Express', 'MongoDB', 'Socket.io'],
    generationTime: '32s'
  },
  {
    title: 'Social Media Dashboard',
    description: 'Analytics platform with user engagement metrics, content scheduling, and multi-platform integration capabilities.',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cc153126-1764661263087.png",
    imageAlt: 'Social media analytics dashboard showing engagement graphs, follower statistics, and content performance metrics on modern interface',
    tags: ['React', 'FastAPI', 'Redis', 'Chart.js'],
    generationTime: '25s'
  },
  {
    title: 'Healthcare Portal',
    description: 'Patient management system with appointment scheduling, medical records, prescription tracking, and telemedicine features.',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_19fdbbf9a-1764635845265.png",
    imageAlt: 'Healthcare portal interface displaying patient records, appointment calendar, and medical data visualization on tablet device',
    tags: ['React', 'Django', 'PostgreSQL', 'WebRTC'],
    generationTime: '35s'
  },
  {
    title: 'Learning Management System',
    description: 'Educational platform with course creation, student enrollment, progress tracking, quizzes, and certification management.',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_146254e45-1764672099813.png",
    imageAlt: 'Learning management system showing course catalog, video player, quiz interface, and student progress dashboard on desktop',
    tags: ['React', 'Node.js', 'MySQL', 'AWS S3'],
    generationTime: '30s'
  },
  {
    title: 'Real Estate Marketplace',
    description: 'Property listing platform with advanced search filters, virtual tours, mortgage calculator, and agent communication tools.',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_11efb8956-1764655545926.png",
    imageAlt: 'Real estate marketplace interface displaying property listings with images, map view, search filters, and contact forms',
    tags: ['React', 'Express', 'PostgreSQL', 'Mapbox'],
    generationTime: '27s'
  }];


  return (
    <section className="py-12 md:py-20 lg:py-28 bg-card">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-14 lg:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3 md:mb-4 lg:mb-5">
            See What You Can Build
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-muted-foreground max-w-2xl mx-auto">
            From simple landing pages to complex enterprise applications—our AI generates production-ready code for any project type.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 lg:gap-10">
          {examples?.map((example, index) =>
          <div
            key={index}
            className="group bg-background border border-border rounded-xl overflow-hidden hover:border-primary/50 transition-all duration-300 hover:shadow-xl hover:shadow-primary/10 hover:-translate-y-1">

              <div className="relative h-48 md:h-56 lg:h-64 overflow-hidden">
                <Image
                src={example?.image}
                alt={example?.imageAlt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />

                <div className="absolute top-3 right-3 md:top-4 md:right-4 lg:top-5 lg:right-5 bg-success text-success-foreground px-3 py-1.5 md:px-4 md:py-2 rounded-full text-xs md:text-sm font-medium flex items-center gap-1.5">
                  <Icon name="Zap" size={14} />
                  <span>{example?.generationTime}</span>
                </div>
              </div>

              <div className="p-5 md:p-6 lg:p-7">
                <h3 className="text-lg md:text-xl lg:text-2xl font-semibold text-foreground mb-2 md:mb-3 lg:mb-4">
                  {example?.title}
                </h3>
                <p className="text-sm md:text-base lg:text-lg text-muted-foreground mb-4 md:mb-5 lg:mb-6 line-clamp-3">
                  {example?.description}
                </p>

                <div className="flex flex-wrap gap-2 md:gap-2.5 lg:gap-3">
                  {example?.tags?.map((tag, tagIndex) =>
                <span
                  key={tagIndex}
                  className="px-2.5 py-1 md:px-3 md:py-1.5 bg-muted text-muted-foreground text-xs md:text-sm rounded-md font-medium">

                      {tag}
                    </span>
                )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default ExamplesGallery;